import type {GraphAtom} from "./graph/GraphAtom"
import {MolecularGraph} from "./graph/MolecularGraph"
import {structuralFeatureExtractor} from "./extractor/structural/structuralFeatureExtractor";
import {functionalGroupExtractor} from "./extractor/functional-group/functionalGroupExtractor";
import {looseAtomsFilter} from "./filter/looseAtomsFilter";
import {bridgingCarbonylPromoter} from "./filter/bridgingCarbonylPromoter";
import {chain1Filter} from "./filter/chain1Filter";
import {bridgeheadFilter} from "./filter/bridgeheadFilter";
import {alkylHalideFilter} from "./filter/alkylHalideFilter";
import {alcoholFilter} from "./filter/alcoholFilter";
import {protonatedFilter} from "./filter/protonatedFilter";
import {epoxideFilter} from "./filter/epoxideFilter";
import {inRingFilter} from "./filter/inRingFilter";
import {methylReclassifyFilter} from "./filter/methylReclassifyFilter";

export const molecularFeatureExtractor = {
    extract: (graph: MolecularGraph) => {
        const features = molecularFeatureExtractor.extractRawFeatures(graph);
        looseAtomsFilter.filterInPlace(features, graph);
        // PIPH-214: Promote a bridging carbonyl carbon to a 1-carbon chain
        // primary by trimming it out of the ketone fg's atoms. Must run before
        // chain1Filter, which would otherwise delete the chain.1 candidate.
        bridgingCarbonylPromoter.filterInPlace(features);
        chain1Filter.filterInPlace(features);
        bridgeheadFilter.filterInPlace(features, graph);
        alkylHalideFilter.filterInPlace(features);
        alcoholFilter.filterInPlace(features);
        epoxideFilter.filterInPlace(features);

        // PIPH-116: Reclassify terminal methyls as functional groups
        methylReclassifyFilter.filterInPlace(features, graph);

        // Check for features that are on a ring
        inRingFilter.filterInPlace(features);

        // Check for protonation after all of the features
        // have been sorted
        protonatedFilter.filterInPlace(features, graph);

        return features;
    },
    removeChainAtom: (a: GraphAtom, chain: GraphAtom[]) => {
        const c = chain.slice();
        const idx = c.indexOf(a);
        c.splice(idx, 1);
        return c;
    },
    extractRawFeatures: (graph: MolecularGraph) => {
        // First get the rings and chains.
        const structuralFeatures = structuralFeatureExtractor.extract(graph);
        const functionalFeatures = functionalGroupExtractor.extract(graph);

        return [...structuralFeatures, ...functionalFeatures];
    }
}
